import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { User } from '../models/user';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/util/data.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
   // Inyecta CookieService

  constructor(private http: HttpClient,
    private _dataService: DataService,
    private cookieService: CookieService
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser') || '{}')
    );
    this.currentUser = this.currentUserSubject.asObservable();

    this.currentUserSubject = new BehaviorSubject<any>(this._dataService.getCurrentUser());

  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  init() {

    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser') || '{}')
    );
    this.currentUser = this.currentUserSubject.asObservable();


  }

  login(username: string, password: string) {

    return this.http.post<User>(`${environment.apiUrl}/authenticate`, { username, password })
      .pipe(
        map((user) => {
          localStorage.setItem('currentUser', JSON.stringify(user));

          this.currentUserSubject.next(user);
          if (user.token) {
            this.cookieService.set('auth', user.token, { secure: true, sameSite: 'Lax' });
          }

          setTimeout(() => {
            window.location.reload();
          }, 1000);

          return user;
        }),
        catchError((error) => {
          return throwError(error); // o maneja el error de otra forma si lo prefieres
        })
      );
  }


  logout() {
    localStorage.removeItem('currentUser');
    this.cookieService.delete('auth');
    localStorage.setItem('logout', Date.now().toString());
    this.currentUserSubject.next(this.currentUserValue); // Asignar un objeto vacío
    return of({ success: false });
  }

  ingresar(user: any) {
    localStorage.setItem('currentUserValue', JSON.stringify(user));
    this.currentUserSubject.next(user);
    return user;

  }





}


export class UserLogin {
  nombre?: string;
  id?: number;
}
